import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/vendorPerformanceActions';
import { vendorPerformanceAPI } from '../../api/config';

function* fetchVendorPerformanceSaga(action) {
  try {
    const { vendorId, params } = action.payload;
    const response = yield call(vendorPerformanceAPI.getVendorScore, vendorId, params);
    yield put(actions.fetchVendorPerformanceSuccess(vendorId, response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch vendor performance';
    yield put(actions.fetchVendorPerformanceFailure(msg));
    message.error(msg);
  }
}

function* fetchAllVendorPerformanceSaga(action) {
  try {
    const response = yield call(vendorPerformanceAPI.getAllVendorScores, action.payload);
    yield put(actions.fetchAllVendorPerformanceSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch vendor performance leaderboard';
    yield put(actions.fetchAllVendorPerformanceFailure(msg));
    message.error(msg);
  }
}

export default function* vendorPerformanceSaga() {
  yield takeLatest(types.FETCH_VENDOR_PERFORMANCE_REQUEST, fetchVendorPerformanceSaga);
  yield takeLatest(types.FETCH_ALL_VENDOR_PERFORMANCE_REQUEST, fetchAllVendorPerformanceSaga);
}
